import { Routes } from '@angular/router';
import {
  RegisterComponent,
  SignInComponent,
  PrivacyPolicyComponent,
  TermsAndConditionsComponent,
  ResetPasswordRequestComponent,
  ResetPasswordComponent
} from './pages';
import { DefaultLayoutComponent } from './layouts';
import { JoinMainComponent } from './join/pages/main';
import { InviteDetailsComponent } from './join/invite/pages/invite-details';

export const ROUTES: Routes = [
  {
    path: '',
    component: DefaultLayoutComponent,
    children: [
      { path: 'resetpassword', component: ResetPasswordRequestComponent, title: 'Reset Password' },
      { path: 'resetpassword/:resetPasswordToken', component: ResetPasswordComponent, title: 'Reset Password' },
      { path: 'privacy', component: PrivacyPolicyComponent, title: 'Privacy' },
      { path: 'terms', component: TermsAndConditionsComponent, title: 'Terms and Conditions' },
      { path: 'signup', component: RegisterComponent, title: 'Sign Up' },
      { path: 'signin', component: SignInComponent, title: 'Sign In' },
      { path: 'signin/:email', component: SignInComponent, title: 'Sign In' },
      { path: 'signin/:email/:resetPasswordToken/:operationToken', component: SignInComponent, title: 'Sign In' },
      {
        path: 'join',
        component: JoinMainComponent,
        children: [
          {
            path: 'invite/:code', component: InviteDetailsComponent, title: 'Join'
          },
        ]
      },
      { path: '**', redirectTo: 'signin' }
    ]
  }
];
